import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import type { FunctionComponent } from 'react';
import type { HotlinePageData } from '../../modules/algebra/global';
import format from 'date-fns/format';

const TOSFooter: FunctionComponent<{ pageData: HotlinePageData }> = ({ pageData }) => {
  const { footerLinks, footerBgColor, footerContent, clientLogo, title, lastUpdatedDate } = pageData;
  return (
    <div>
      <Typography component="div" className="hotline-footer bg-tc-9" style={{ backgroundColor: footerBgColor }}>
        <Container maxWidth={false}>
          <Grid container direction="row" spacing={0}>
            <Grid item md={12} className="">
              <Typography component="h6" className="text-center text-tc-1 py-5 font-notosans">
                To provide feedback on this webpage and its content, please contact
                <Link href="mailto:cases@rainn.org" className="font-bold text-tc-1 ml-1">
                  cases@rainn.org
                </Link>
              </Typography>
            </Grid>
            <Grid item md={12} className="p-0">
              <Divider orientation="horizontal" variant="fullWidth" />
            </Grid>
            <Grid item sm={6} className="items-center pt-4">
              <Grid container alignItems="flex-start" spacing={2}>
                <Grid item xs={2}>
                  <img className="w-44 md:h-full md:w-32" src={clientLogo} alt="Rainn Logo" />
                </Grid>
                <Grid item xs={10}>
                  <Typography variant="body1" className=" text-tc-1 text-base font-notosans mb-4">
                    {title}
                  </Typography>
                  <Typography variant="body1" className=" text-tc-1 text-sm font-notosans">
                    {footerContent}
                  </Typography>
                </Grid>
                <Grid item xs={12}></Grid>
              </Grid>
            </Grid>
            <Grid item md={1} className=""></Grid>
            <Grid item md={5} className="">
              <List className="grid grid-cols-3 p-4 footer-links">
                {footerLinks?.map((link) => {
                  return (
                    <ListItem className="col-span-1">
                      <Link href={link.url}>{link.label}</Link>
                    </ListItem>
                  );
                })}
              </List>
            </Grid>
            <Grid item md={12} className="p-0">
              <Divider orientation="horizontal" variant="fullWidth" />
            </Grid>
          </Grid>
        </Container>
        <Typography component="div" className="copyright-links">
          <Container>
            <Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} className="flex flex-wrap justify-start md:justify-center">
              <List className="flex flex-col md:flex-row">
                <ListItem disableGutters>
                  <Link href="https://www.rainn.org">© RAINN {new Date().getFullYear()}</Link>
                </ListItem>
                <ListItem disableGutters>
                  <Link href="https://www.rainn.org/online-privacy-policy">Privacy Policy</Link>
                </ListItem>
                <ListItem disableGutters>
                  <Link href="https://rainn.org/terms-service">Terms of Service</Link>
                </ListItem>
                <ListItem disableGutters>
                  <Link href="https://rainn.org/federal-funding-disclaimer">Federal Funding Disclaimer</Link>
                </ListItem>
              </List>
            </Grid>
          </Container>
        </Typography>
        {lastUpdatedDate && (
          <Grid item md={12} className="p-0">
            <Divider orientation="horizontal" variant="fullWidth" />
            <Typography component="h6" className="text-center text-tc-1 text-sm py-5 font-notosans">
              Content last updated on&nbsp; {format(new Date(lastUpdatedDate), 'MMM dd, yyyy')}
            </Typography>
          </Grid>
        )}
      </Typography>
    </div>
  );
};

export default TOSFooter;
